(function () {
  'use strict';

  const root = document.querySelector('.am-compare');
  if (!root) return;

  const tabs = [...root.querySelectorAll('[data-compare-tab]')];
  const panels = [...root.querySelectorAll('[data-compare-panel]')];
  const panelWrap = root.querySelector('[data-compare-panels]');
  let activeIndex = 0;
  let touchStartX = 0;

  function activate(index, focusTab) {
    activeIndex = (index + tabs.length) % tabs.length;
    tabs.forEach((tab, i) => {
      const selected = i === activeIndex;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });
    panels.forEach((panel, i) => {
      panel.hidden = i !== activeIndex;
      panel.classList.toggle('is-active', i === activeIndex);
    });
    if (focusTab) tabs[activeIndex].focus();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index, false));
    tab.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); activate(index + 1, true); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); activate(index - 1, true); }
      if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
      if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
    });
  });

  if (panelWrap) {
    panelWrap.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
    }, { passive: true });

    panelWrap.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 48) return;
      activate(activeIndex + (distance < 0 ? 1 : -1), false);
    }, { passive: true });
  }
})();
